<script setup lang="ts">
import {LegacyAddress, LegacyDelivery, LegacyOrder, legacyOrderKey, useLocalization} from '@hantera/portal-app';
import {computed, inject, Ref} from 'vue';
import OrderAddress from './LegacyOrderAddress.vue';

const order = inject(legacyOrderKey, <Ref<LegacyOrder>>{});
const t = useLocalization();

interface AddressContainer {
  key: string
  address: LegacyAddress
  deliveries: LegacyDelivery[]
  isInvoiceAddress: boolean
};

function addressToKey(address: LegacyAddress) {
  return [
    address.address1,
    address.address2,
    address.city,
    address.countryCode,
    address.email,
    address.firstName,
    address.lastName,
    address.phoneNumber,
    address.state,
    address.postalCode].join('$').toLowerCase().replaceAll(' ', '');
}

const addresses = computed(() => {

  const addresses = order.value.deliveries.reduce((res, d) => {
    const key = addressToKey(d.deliveryAddress);
    if (!res[key]) {
      res[key] = {
        key,
        address: d.deliveryAddress,
        deliveries: [d],
        isInvoiceAddress: false
      };
    } else {
      res[key].deliveries.push(d);
    }
    return res;
  }, <{
    [key: string]: AddressContainer
  }>{});

  if (order.value.invoiceAddress) {
    const invoiceKey = addressToKey(order.value.invoiceAddress);
    let invoiceAddress = addresses[invoiceKey];
    if (invoiceAddress) {
      invoiceAddress.isInvoiceAddress = true;
    } else {
      addresses[invoiceKey] = {
        key: invoiceKey,
        address: order.value.invoiceAddress,
        deliveries: [],
        isInvoiceAddress: true,
      };
    }
  }

  return Object.values(addresses);
});


</script>

<template>
  <div>
    <div class="box-content-label">
      {{t('orderView.addresses')}}
    </div>
    <div class="box-content box-pop delivery-addresses">
      <OrderAddress
        v-for="entry in addresses"
        :key="entry.key"
        :address="entry.address"
        :deliveries="entry.deliveries"
        :is-invoice-address="entry.isInvoiceAddress"
      />
    </div>
  </div>
</template>

<style>
.delivery-addresses {
  display: flex;
  flex-direction: column;
}

.delivery-addresses__title {
  font-weight: 500;
}
</style>